import { Command } from "@ckeditor/ckeditor5-core";

export default class ApplyCBTPBTCommand extends Command {
  execute(type) {
    const editor = this.editor;
    const model = editor.model;

    model.change((writer) => {
      let selection = model.document.selection;

      // Determine what the "other" type is (so that it can be removed)
      const other = ["cbt", "pbt"].filter((s) => s !== type).shift();

      // Get the first position to determine what actions will be taken
      const position = selection.getFirstPosition();

      // Get the ancestors (if any)
      const otherParent = position.findAncestor(other);
      const typeParent = position.findAncestor(type);

      // If the user has the cursor inside a block without having selected text
      if (selection.isCollapsed) {
        // If the cursor is inside the selected type, remove it
        if (typeParent) {
          writer.unwrap(typeParent);
        }
        // If the cursor is inside the opposite type, switch to the new type
        if (otherParent) {
          writer.rename(otherParent, type);
        }
      }
      // If the user has selected text and the selection is not inside a CBT or PBT element
      else if (!otherParent && !typeParent) {
        // Wrap the selected text in the given style
        for (const range of selection.getRanges()) {
          writer.wrap(range, type);
        }
      }
    });
  }

  refresh() {
    const model = this.editor.model;
    const selection = model.document.selection;

    const allowedIn = model.schema.findAllowedParent(
      selection.getFirstPosition(),
      "$text",
    );

    const checkExistence = (type) => {
      const position = selection.getFirstPosition();
      const ancestor = position?.findAncestor(type);
      return !!ancestor;
    };

    this.isCBTOn = checkExistence("cbt");
    this.isPBTOn = checkExistence("pbt");
    this.isEnabled = selection && allowedIn !== null;
  }
}
